module.exports = __webpack_public_path__ + "media/images/new/ad_free_experience_phone-0ee12bf57aebd84c140eacdc2aa79352.png";